// organize-imports-ignore — the stylesheet goes first on purpose: stylesheets
// imported by the modules below must come after the global ones in the cascade.
import "./styles.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ErrorBoundary } from "./components/error-boundary.js";
import { ToastProvider } from "./components/toast.js";
import { App } from "./router.js";
import { Sparks } from "./components/pixel-art/sparks.js";
import { reloadOnStaleBuild } from "./lib/stale-build.js";

const client = new QueryClient({
  defaultOptions: {
    queries: {
      // A failed read is shown, not retried into a spinner that never resolves.
      // The screens say what went wrong; hiding it behind retries would turn a
      // clear error into an apparently hung page.
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Before anything lazy loads: a tab left open across a release reloads onto
// the new build instead of crashing on a chunk the server no longer has.
reloadOnStaleBuild(window);

const container = document.getElementById("root");
if (container === null) {
  // Nothing sensible to render into. Failing loudly beats a blank page whose
  // cause is invisible.
  throw new Error("#root is missing from index.html");
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={client}>
      {/* The last line: a crash in the rail, sign-in or setup, which sit
          outside the per-screen boundary in `app.tsx`. */}
      <ErrorBoundary>
        <ToastProvider>
          <App />
          <Sparks />
        </ToastProvider>
      </ErrorBoundary>
    </QueryClientProvider>
  </StrictMode>,
);
